export default __webpack_public_path__ + "static/media/domain-left-img.10f3b4dc.png";